// Forked from: https://github.com/YChebotaev/json-decycle/blob/master/src/index.ts
// Replaced `$ref` with `$reference` to avoid conflicts with OpenAPI
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var isObject = function (value) {
    return typeof value === 'object' &&
        value != null &&
        !(value instanceof Boolean) &&
        !(value instanceof Date) &&
        !(value instanceof Number) &&
        !(value instanceof RegExp) &&
        !(value instanceof String);
};
var toPointer = function (parts) {
    return "#".concat(parts.map(function (part) { return String(part).replace(/~/g, '~0').replace(/\//g, '~1'); }).join('/'));
};
export var decycle = function () {
    var paths = new WeakMap();
    return function replacer(key, value) {
        var _a;
        if (key !== '$reference' && isObject(value)) {
            var seen = paths.has(value);
            if (seen) {
                return { $reference: toPointer(paths.get(value)) };
            }
            paths.set(value, __spreadArray(__spreadArray([], ((_a = paths.get(this)) !== null && _a !== void 0 ? _a : []), true), [key], false));
        }
        return value;
    };
};
export function retrocycle() {
    var parents = new WeakMap();
    var keys = new WeakMap();
    var refs = new Set();
    function dereference(ref) {
        var _a;
        var parts = ref.$reference.slice(1).split('/');
        var key;
        var value = this;
        for (var i = 0; i < parts.length; i++) {
            key = (_a = parts[i]) === null || _a === void 0 ? void 0 : _a.replace(/~1/g, '/').replace(/~0/g, '~');
            value = value[key];
        }
        var parent = parents.get(ref);
        parent[keys.get(ref)] = value;
    }
    return function reviver(key, value) {
        if (key === '$reference') {
            refs.add(this);
        }
        else if (isObject(value)) {
            var isRoot = key === '' && Object.keys(this).length === 1;
            if (isRoot) {
                refs.forEach(dereference, this);
            }
            else {
                parents.set(value, this);
                keys.set(value, key);
            }
        }
        return value;
    };
}
